import React, { useEffect, useState } from 'react';

/**
 * Hidden draggable element at the bottom of the page for drag-and-drop functionality.
 */
function PageBottomHiddenDraggable(props) {
    return (
        <React.Fragment>
            <div id="bottom-hidden-enter" className="bottom-hidden hidden draggable" onDragEnter={props.onDragEnter} />
            <div id="bottom-hidden-exit" className="bottom-hidden hidden draggable" onDragEnter={props.onDragEnter} />
        </React.Fragment>
    );
}

/**
 * Hidden draggable element at the top of the page for drag-and-drop functionality.
 */
function PageTopHiddenDraggable(props) {
    const [exitOffset, setExitOffset] = useState(undefined);
    const [style, setStyle] = useState({ cursor: 'default' });
    useEffect(() => {
        const _style = { cursor: 'default' };
        if (props.pageEmpty) {
            _style.bottom = 0;
            _style.height = 'auto';
        } else {
            const paddingTop = parseFloat(props.offset);
            if (!isNaN(paddingTop) && paddingTop > 4.0) {
                _style.height = `${paddingTop}px`;
                if (props.adjustTop) {
                    _style.top = `-${paddingTop}px`;
                    setExitOffset(`-${30.0 + paddingTop}px`);
                }
            }
        }
        setStyle(_style);
    }, [props.offset, props.pageEmpty]);
    return (
        <React.Fragment>
            <div id="top-hidden-exit" className="hidden draggable" style={exitOffset != undefined ? { top: exitOffset } : undefined} onDragEnter={props.onDragEnter} />
            <div id="top-hidden-enter" className="hidden draggable" style={style} onDragEnter={props.onDragEnter} />
        </React.Fragment>
    );
}

export {
    PageBottomHiddenDraggable,
    PageTopHiddenDraggable
};

